











































































































































































import { Vue, Component } from "../vue-ext";
import { HousingCompany, Account, OwnInfo, User, MessageType } from "../models";
import "../components/YesNoPopup";
import "../components/CustomPopup";

@Component
export default class OwnInfoView extends Vue {
    private account: Account | null = null; 
    private user: User | null = null;
    private housingCompany: HousingCompany | null = null;
    private ownInfos: OwnInfo[] | null = null;
    private selectedInfo: OwnInfo | null = null;
    private confirmOpen: boolean = false;
    private selectedAccountId: number | null = null;

    private editUserName: boolean = false;
    private editEmail: boolean = false;
    private editPhone: boolean = false;
    private confirmEmail: boolean = false;
    private confirmPhone: boolean = false;

    private newFirstName: string = "";
    private newLastName: string = "";
    private newEmail: string = "";
    private emailPin: string = "";
    private newPhone: string = "";
    private phonePin: string = "";

    private async created() {
        this.root.setTitle(this.$t("menu.ownInfo") as string);
        this.root.setIconClass("icon-user1");
        
        this.account = this.root.getCurrentAccount() as Account;
        this.user = this.root.getCurrentUser() as User;
        this.newFirstName = this.user.firstName;
        this.newLastName = this.user.lastName;
        this.newEmail = this.user.email;
        this.newPhone = this.user.phone;
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        this.ownInfos = await this.root.service.user.GetOwnInfo();
    }

    private async remove(accountId: number) {
        this.selectedAccountId = accountId;
        this.confirmOpen = true;
    }

    private async confirmRemoveYes() {
        if (this.selectedAccountId) {
            if (await this.root.service.user.RemoveHousingCompany(this.selectedAccountId)) {
                if (this.ownInfos && this.selectedInfo) {
                    this.ownInfos = this.ownInfos.filter(o => o.accountId !== this.selectedAccountId);
                    let user = this.root.getCurrentUser() as User;
                    user.accounts = user.accounts.filter(a => a.accountId != this.selectedAccountId);
                }
            } else {
                alert("Ei onnistunut");
            }
        }

        this.confirmOpen = false;
    }

    private confirmRemoveNo() {
        this.selectedAccountId = null;
        this.confirmOpen = false;
    }

    private editOwnInfo() {
        this.root.setCurrentOwnInfo(this.selectedInfo);
        this.$router.push("/content/own-info/edit");
    }

    private async createPinConfirm(address: string, messageType: MessageType) {

        if ((messageType == MessageType.Email && this.user!.email == address) == true
                && (messageType == MessageType.Sms && this.user!.phone == address) == true) {
            this.root.setOkPopupOpen(true, this.$t("errorCodes.UpdateOwnInfoNoChanges") as string);
            return;
        }

        let res = await this.root.service.user.SendConfirmPin(address, messageType);

        if (!res.isError) {
            if (messageType == MessageType.Email)
                this.confirmEmail = true;

            else if (messageType == MessageType.Sms)
                this.confirmPhone = true;
        }
    }

    private async updateOwnUserName() {
        let res = await this.root.service.user.UpdateOwnUserName(this.newFirstName, this.newLastName);

        if (!res.isError) {
            this.root.setOkPopupOpen(true, this.$t("ownInfoView.changedOwnInfoSuccessfully") as string);
            this.user!.displayName = `${this.newFirstName} ${this.newLastName}`;
            this.editUserName = false;
        }
    }

    private async updateOwnContact(address: string, messageType: MessageType, pin: string) {
        let res = await this.root.service.user.UpdateOwnContact(address, messageType, pin);

        if (!res.isError) {
            this.root.setOkPopupOpen(true, this.$t("ownInfoView.changedOwnInfoSuccessfully") as string);

            if (messageType == MessageType.Email) {
                this.user!.email = this.newEmail;
                this.editEmail = false;
                this.confirmEmail = false;
                this.emailPin = "";
            } else if (messageType == MessageType.Sms) {
                this.user!.phone = this.newPhone;
                this.editPhone = false;
                this.confirmPhone = false;
                this.phonePin = "";
            }
        }
    }
}
